<p>password-reset-succeeded works!</p>
